import Vue from 'vue'
import config from 'client/config'
import store from 'client/store'
import { createLegacyMonitor, legacyRoleContext } from 'lib/legacyMonitor'

const collections = ['categories', 'participations', 'exercises', 'rankings', 'blockParticipations',
  'panels', 'members', 'groups', 'teams', 'clubs']

const monitor = createLegacyMonitor({
  snapshot: (role, eventId, eventDisciplineId) => Vue.http.get(
    `${config.root}/events/${encodeURIComponent(eventId)}/monitor`,
    { params: { role, eventDisciplineId } }
  ).then(response => response.data),
  detail: (eventId, exerciseId) => Vue.http.get(
    `${config.root}/events/${encodeURIComponent(eventId)}/monitor-exercise`,
    { params: { exerciseId } }
  ).then(response => response.data),
  apply(data, context, detail) {
    store.commit('events.setCurrent', data.event)
    store.commit('eventDisciplines.setItems', data.disciplines)
    store.commit('sessions.setItems', data.sessions)
    if (data.config) {
      collections.forEach(name => store.commit(`${name}.setItems`, data[name] || []))
      store.commit('blocks.setData', data.blocks || [])
      store.commit('panels.setConfigurations', data.configurations || [])
      store.commit('eventDiscipline.setId', context.disciplineId)
      store.commit('eventDiscipline.setData', data.config)
    }
    if (detail) store.dispatch('exercise.applyMonitor', detail)
    else store.commit('exercise.update', undefined)
    if (data.event.language) Vue.i18n.locale = data.event.language
  },
  visible: () => !document.hidden,
  onError: error => {
    // Keep the last snapshot on transient failures, and retry at the normal interval.
    console.error('Unable to refresh the event role view', error.status || error.message)
  },
})

document.addEventListener('visibilitychange', () => {
  if (!document.hidden) monitor.refresh().catch(() => {})
})

export { legacyRoleContext }
export default monitor
